import Api from './Api';
import Configuracao from '../util/Configuracao';

class DividaServDesligadoPagtoApi extends Api {
  async consultarTitulares () {
    try {
      const urlConsultarTitulares = Configuracao.getConfiguracao().urlConsultarTitulares;
      const response = await this.fetch(urlConsultarTitulares);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarTitularesComDivida () {
    try {
      const urlConsultarTitularesComDivida = Configuracao.getConfiguracao().urlConsultarTitularesComDivida;
      const response = await this.fetch(urlConsultarTitularesComDivida);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarPagtos (numMatricula, dataInicial, dataFinal, apenasSemBaixa) {
    try {
      const pagtoUrl = Configuracao.getConfiguracao().urlConsultarPagtosServDesligado +
      numMatricula + '/' +
      dataInicial + '/' +
      dataFinal + '/' + 
      apenasSemBaixa;
      const response = await this.fetch(pagtoUrl, 'post');
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirPagto (pagto) {
    try {
      const urlIncluirPagto = Configuracao.getConfiguracao().urlIncluirPagto;
      const response = await this.fetch(urlIncluirPagto, 'put', pagto);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarPagto (pagto) {
    try {
      const urlAlterarPagto = Configuracao.getConfiguracao().urlAlterarPagto;
      const response = await this.fetch(urlAlterarPagto, 'put', pagto);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirPagto (numPagto) {
    try {
      const urlExcluirPagto = Configuracao.getConfiguracao().urlExcluirPagto + numPagto;
      const response = await this.fetch(urlExcluirPagto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async cancelarPagto (numPagto, motivoCancelamento) {
    try {
      const urlCancelarPagto = Configuracao.getConfiguracao().urlCancelarPagto + numPagto + '/' + motivoCancelamento;
      const response = await this.fetch(urlCancelarPagto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async desfazerCancelamentoPagto (numPagto) {
    try {
      const urlDesfazerCancelamentoPagto = Configuracao.getConfiguracao().urlDesfazerCancelamentoPagto + numPagto;
      const response = await this.fetch(urlDesfazerCancelamentoPagto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async baixarPagto (pagto) {
    try {
      const urlBaixarPagto = Configuracao.getConfiguracao().urlBaixarPagto;
      const response = await this.fetch(urlBaixarPagto, 'put', pagto);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}
export default DividaServDesligadoPagtoApi;
